<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" [disabled]="disabled()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th scope="col">Finalidade</th>
      <th scope="col">Credor/fornecedor</th>
      <th scope="col">Evento</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel" style="width: 10%">{{this.globalService.obterFinalidade(item.finalidade)}}</td>
      <td *ngIf="!item.editavel" style="width: 10%">{{item.tipo_fornecedor === 'F' ? 'FORNECEDOR' : item.tipo_fornecedor === 'C' ? 'CREDOR' : 'AMBOS' }}</td>
      <td *ngIf="!item.editavel" style="width: 75%">{{this.globalService.obterEspecie(item.especie)}}</td>
    
      <td *ngIf="item.editavel" style="width: 25%">
        <select id="finalidade" [(ngModel)]="item.finalidade" class="custom-select custom-select-sm">
          <option [ngValue]="item.id" *ngFor="let item of listaFinalidade">
            {{item.nome}}
          </option>
        </select>
      </td>
      <td *ngIf="item.editavel" style="width: 25%">
        <select id="tipo_fornecedor" [(ngModel)]="item.tipo_fornecedor" class="custom-select custom-select-sm">
          <option [ngValue]="item.id" *ngFor="let item of listaTipoFavorecido">
            {{item.nome}}
          </option>
        </select>       
      </td>
      <td *ngIf="item.editavel" style="width: 75%">
        <select [(ngModel)]="item.especie" id="especie" class="custom-select custom-select-sm">
          <option *ngFor="let item of listaEventos" [value]="item.id">{{item.nome}}</option>
        </select>
      </td>
      <td class="text-right" style="min-width: 120px;">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="editar(item)" [disabled]="disabled()"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item, idx)" [disabled]="disabled()"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>